import Container from "../components/layout/Container";
import PageHeader from "../components/layout/PageHeader";
import TextLink from "../components/ui/TextLink";

export default function NotFoundPage() {
  return (
    <>
      <PageHeader title="Page not found" lede="This address is not part of the site." />
      <Container className="pb-24">
        <TextLink href="/">Back home</TextLink>
      </Container>
    </>
  );
}
